/* eslint-disable @typescript-eslint/no-explicit-any */
import { css } from 'styled-components';
export const breakpoints = {
  sm: '36rem',
  md: '48rem',
  lg: '64rem',
  xl: '80rem',
  mobile: '769px'
};
export const breakpoint = Object.entries(breakpoints).reduce((acc, [size, breakpoint]) => {
  acc[size] = (literals, ...placeholders) => css`
      @media (min-width: ${breakpoint}) {
        ${css(literals, ...placeholders)};
      }
    `;
  return acc;
}, {});
export default {
  breakpoints,
  breakpoint
};
//# sourceMappingURL=breakpoints.js.map